<template>
    <div>
        <div class="d-flex banner align-center px-5" :class="'banner-' + usage">
            <v-icon v-if="usage === 'success'" class="banner-icon" color="#0EA449">fas fa-check-circle</v-icon>
            <v-icon v-else-if="usage === 'info'" class="banner-icon" color="#2B87FF">fas fa-info-circle</v-icon>
            <v-icon v-else class="banner-icon" color="#BF0D00">fas fa-exclamation-circle</v-icon>
            <div class="banner-body" style="width: 100%;">
                <div v-if="title" class="banner-title">{{ title }}</div>
                <slot name="banner-body">
                    <div class="banner-message">{{ text }}</div>
                </slot>
            </div>
            <div v-if="closable" 
                data-test="banner-close-btn"
                tabindex="0"
                role="button"
                style="cursor: pointer;"
                @click="$emit('close')"
                @keydown.enter="$emit('close')"
                @keydown.space.prevent="$emit('close')"
                aria-label="Close Banner"
            >
                <v-icon>fal fa-times</v-icon>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Banner',

        props: {
            text: {
                type: String,
                default: 'this is a message'
            },
            usage: {
                type: String,
                default: 'success'
            },
            title: {
                type: String,
                default: null
            },
            closable: {
                type: Boolean,
                default: false,
            },
        }
    }
</script>

<style lang="scss" scoped>
.banner {
    border-radius: 16px;
    min-height: 56px;
    color: #050F2D !important;
    &-success {
        border: 1px solid #0EA449;
        background: #ECF9F0;
    }
    &-info {
        border: 1px solid #2B87FF;
        background: #EFF3F9;
    }
    &-warning {
        border: 1px solid #BF0D00;
        background: #F8EEED;
    }
    &-message {
        line-height: 20px;
        font-size: 14px;
    }
    &-icon {
        font-size: 24px !important;
    }
    &-body {
        padding: 16px 12px;
    }
    &-title {
        font-family: 'HyperlegibleSans-Medium', Hyperlegible Sans, 'Roboto', sans-serif !important;
    }
}
</style>